import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-permissions-settings',
    templateUrl: './permissions-settings.component.html',
    styleUrls: ['./permissions-settings.component.scss'],
    host: {
        class: 'app-permissions-settings'
    },
    standalone: false
})
export class PermissionsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

  initForm() { }

  updatePermissionsSettings() { }

}
